export default "__VITE_ASSET__DYT_Oknm__"